import { initialAppState } from "../../common/reducers/appState";
import { getCookiebyName } from "../../common/services/Utilities";
import { KeyValue } from "../../interfaces";
import { Buffer } from "buffer";

export default function peerGroupCustomCompareData(
  peerGroups: string[],
  customState?: KeyValue[],
  individualState?: KeyValue[],
  editId?: string,
  standardGroupSearchPills?: KeyValue[],
) {
  const singleCert = individualState
    ? individualState?.map((cert: KeyValue) => cert)
    : [];
  const multiCert = customState
    ? customState
        ?.map((custom: KeyValue) => custom.formKey === "cert" && custom)
        .filter((val) => val)
    : [];
  const searchCriteria = customState
    ? customState
        ?.map((custom: KeyValue) => custom.formKey === "search" && custom)
        .filter((val) => val)
    : [];
  const standardPeerGroupLookup = standardGroupSearchPills?.length
    ? standardGroupSearchPills.reduce(
        (acc, pill: KeyValue) => {
          if (pill.short_name) {
            acc[pill.short_name] = pill.value;
          }
          return acc;
        },
        {} as Record<string, any>,
      )
    : {};

  return peerGroups?.map((id: string) => {
    const individualCertData = singleCert.find(
      (cert) => cert && cert.value === id,
    );
    const isIndividual = singleCert
      ?.map((cert: KeyValue) => cert.value)
      .includes(id);
    const multiCertData = multiCert.find(
      (multi) => multi && multi.value === id,
    );

    const searchData = searchCriteria.find(
      (search) => search && search.value === id,
    );

    const standardPGData = standardGroupSearchPills?.length
      ? standardGroupSearchPills.find(
          (search) => search && search.short_name === id,
        )
      : undefined;

    const peerGroupAppState = initialAppState.peerGroup;
    const appState =
      searchData && searchData?.pillData
        ? {
            filters: searchData.pillData[0].appState.filters,
            search: searchData.pillData[0].appState.search,
            ui: {},
          }
        : multiCertData
          ? {
              filters: {
                ...peerGroupAppState.filters,
                reportPeriod: [multiCertData.reportPeriod],
                multiCert: multiCertData.pillData,
              },
              search: {},
              ui: {},
            }
          : individualCertData
            ? {
                filters: {
                  ...peerGroupAppState.filters,
                  reportPeriod: [
                    isIndividual && individualCertData
                      ? individualCertData.reportPeriod
                      : "",
                  ],
                  cert: id,
                },
                search: {},
                ui: {},
              }
            : {
                filters: standardPGData ? standardPGData.filter_criteria : {},
                title: standardPGData?.value,
                custom: false,
                is_standard: standardPGData,
                search: {},
                ui: {},
                reportPeriod: standardPGData?.reportPeriod,
              };
    return {
      filter_criteria: standardPGData?.filter_criteria
        ? standardPGData.filter_criteria
        : searchData && searchData?.pillData
          ? searchData.pillData.map((pill: KeyValue) => {
              return {
                value: pill.value,
                search: pill.search,
                variable: pill.label,
              };
            })
          : multiCertData
            ? [
                {
                  value: multiCertData.pillData,
                  variable: "CERT",
                },
              ]
            : [
                {
                  value: id,
                  variable: "CERT",
                },
              ],
      name:
        isIndividual && individualCertData
          ? individualCertData.bankName
          : standardPeerGroupLookup.hasOwnProperty(id)
            ? standardPeerGroupLookup[id]
            : id,
      isMultiCert: multiCert.length > 0,
      maxReportDate:
        isIndividual && individualCertData
          ? individualCertData.maxRepDate
          : undefined,
      minReportDate:
        isIndividual && individualCertData
          ? individualCertData.minRepDate
          : undefined,
      is_custom: !standardPeerGroupLookup.hasOwnProperty(id),
      short_name: id.replace(/[^a-zA-Z0-9]/g, ""),
      altColor: isIndividual,
      saved_state: appState
        ? Buffer.from(JSON.stringify(appState)).toString("base64")
        : undefined,
      peerGroupTitle: isIndividual ? `FDIC Cert - ${id}` : "Peer Group",
      created_by: getCookiebyName("uuid") ? getCookiebyName("uuid") : undefined,
      ID: editId
        ? editId
        : getCookiebyName("uuid")
          ? `${getCookiebyName("uuid")}_${Date.now()}`
          : undefined,
      groupID: id,
    };
  });
}
